<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Alterar valores da cobrança
          </h4>
        </div>
        <div class="modal-body">
          <div v-if="errorMessage" class="alert alert-danger">
            {{ errorMessage }}
          </div>
          <table class="table table-striped modal__table">
            <tbody>
              <tr>
                <th>ID da billing</th>
                <td>{{ billing.id }}</td>
              </tr>
              <tr>
                <th>Valor sem desconto</th>
                <td>R$ {{ billing.installment_value_without_discount }}</td>
              </tr>
              <tr>
                <th>Valor com desconto</th>
                <td>R$ {{ billing.installment_value_with_discount }}</td>
              </tr>
              <tr>
                <th>Desconto</th>
                <td>{{ billing.discount_percentage }} %</td>
              </tr>
            </tbody>
          </table>
          <p>Novos valores:</p>
          <money-field
            label="Valor sem desconto"
            v-model="billingForm.get('valueWithoutDiscount').value"
            :errors="billingForm.get('valueWithoutDiscount').errors"
            @input="billingForm.get('valueWithoutDiscount').validateField()"
          />
          <money-field
            label="Valor com desconto"
            v-model="billingForm.get('valueWithDiscount').value"
            :errors="billingForm.get('valueWithDiscount').errors"
            @input="billingForm.get('valueWithDiscount').validateField()"
          />
          <table class="table table-striped modal__table">
            <tbody>
              <tr>
                <th>Novo Desconto:</th>
                <td id="calculatedDiscount">
                  {{ calculateDiscount }} %
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="changeBillingValue">
            Salvar
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { MoneyField } from 'components/form';
import { FormGroup } from 'utils/form';
import BillingsService from 'services/BillingsService';

export default {
  components: {
    MoneyField,
  },
  props: {
    billing: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      billingForm: new FormGroup({
        valueWithDiscount: {
          required: true,
          value: 0,
        },
        valueWithoutDiscount: {
          required: true,
          value: 0,
        },
      }),
      errorMessage: null,
    };
  },
  computed: {
    calculateDiscount() {
      const valueWithoutDiscount = this.billingForm.get('valueWithoutDiscount').value;
      const valueWithDiscount = this.billingForm.get('valueWithDiscount').value;
      const discountValue = (1 - valueWithDiscount / valueWithoutDiscount) * 100;
      return Number.isNaN(discountValue) ? 0 : discountValue.toFixed(2);
    },
  },
  methods: {
    ...mapActions([
      'loadStudentBillings',
    ]),
    changeBillingValue() {
      this.$loader.show();
      const payload = this.billingForm.getRawValue();
      BillingsService.billingValueChange(this.billing.id, payload)
        .then(() => {
          Promise.all([
            this.loadStudentBillings(),
          ]);
        })
        .then(() => {
          this.$emit('close');
          this.$alert.notifySuccess('Alteração efetuada com sucesso');
        })
        .catch(() => {
          this.errorMessage = 'Erro ao Alterar o valor';
        })
        .finally(() => {
          this.$loader.hide();
        });
    },
  },
};
</script>
